import {createAsyncThunk} from "@reduxjs/toolkit";
import {AxiosResponse} from "axios";
import instance from "@/config/axios";

export const getPrograms = createAsyncThunk('programSummary/getPrograms',
  async (params: any) => {
    const paramText = new URLSearchParams(params)
    const response: AxiosResponse<GeneralArrayResponse<Program>> = await instance.get(`v1/programs?${paramText}`)
    return response.data
  })

export const getProgramsSummary = createAsyncThunk('programSummary/getProgramsSummary',
  async (params: any) => {
    const paramText = new URLSearchParams(params)
    const response: AxiosResponse<ProgramSummary> = await instance.get(`/v1/programs/type-summary?${paramText}`)
    return response.data
  })

export const deleteProgram = createAsyncThunk('programSummary/deleteProgram',
  async (id: string, {dispatch}) => {
    const response: AxiosResponse = await instance.delete(`v1/programs/${id}`)
    dispatch(getPrograms({}))
    return response.data
  })